import { Injectable, inject } from '@angular/core';
import { BaseApiService } from '@bo/ng-api';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  AccountingWidget,
  AccountBalanceWidget,
  AverageSpendWidget,
  TransactionsWidget,
  VirtualCardsWidget,
} from '../../_interfaces/dashboard.interface';

@Injectable({
  providedIn: 'root',
})
export class DashboardApiService extends BaseApiService {
  protected override http: HttpClient;

  override baseUrl: string = environment.apiRoot;
  URL_DASHBOARD_CARDS: string = 'dashboard/card';
  URL_DASHBOARD_TRANSACTIONS: string = 'dashboard/transaction';
  URL_DASHBOARD_SPEND: string = 'dashboard/spend';
  URL_DASHBOARD_BALANCE: string = 'dashboard/balance';
  URL_DASHBOARD_ACCOUNTING: string = 'dashboard/accounting';

  constructor() {
    const http = inject(HttpClient);

    super(http);

    this.http = http;
  }

  /**
   * Get all virtual card widget details
   *
   * @return Observable<VirtualCardsWidget>
   */
  getCardWidgetDetails() {
    return this.http.get<VirtualCardsWidget>(this.getUrl(this.URL_DASHBOARD_CARDS, true));
  }

  /**
   * Get transactions and receipts count widget details
   *
   * @return Observable<TransactionsWidget>
   */
  getTransactionsWidgetDetails() {
    return this.http.get<TransactionsWidget>(this.getUrl(this.URL_DASHBOARD_TRANSACTIONS, true));
  }

  /**
   * Get average monthly spend widget details
   *
   * @return Observable<AverageSpendWidget>
   */
  getAverageSpendDetails() {
    return this.http.get<AverageSpendWidget>(this.getUrl(this.URL_DASHBOARD_SPEND, true));
  }

  /**
   * Get account balance
   *
   * @return Observable<AccountBalanceWidget>
   */
  getAccountBalance() {
    return this.http.get<AccountBalanceWidget>(this.getUrl(this.URL_DASHBOARD_BALANCE, true));
  }

  /**
   * Get accounting linked widget details
   *
   * @return Observable<AccountingWidget>
   */
  getAccountingWidgetDetails() {
    return this.http.get<AccountingWidget>(this.getUrl(this.URL_DASHBOARD_ACCOUNTING, true));
  }
}
